import React from "react";

const sb404 = (props) => (
  <div className="w-100 vh-100 d-flex justify-content-center align-items-center">
    There is no preview for this template
  </div>
);

export default sb404;
